import { render } from "./QuickAddStation.vue?vue&type=template&id=28a5d622&scoped=true"
import script from "./QuickAddStation.vue?vue&type=script&lang=js"
export * from "./QuickAddStation.vue?vue&type=script&lang=js"

import "./QuickAddStation.vue?vue&type=style&index=0&id=28a5d622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a5d622"]])

export default __exports__